import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import NotificationActions from '../NotificationActions';

const AdLinkTemplates = new ReduxAsyncAction('GET_AD_LINK_TEMPLATES');
AdLinkTemplates.registerRequest(async (pagesize: number) => {
  try {
    const { data } = await dash_api.get(`/v1/linkhub/templates`, { params: { pagesize, filter: { type: 'ad' } } });
    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch templates.', 'error');
    throw error;
  }
});
export const getAdLinkTemplates = AdLinkTemplates.request;
export const GET_AD_LINK_TEMPLATES: any = AdLinkTemplates.constants;
